<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary text-center">
        <div class="h4">
        	<linkto :link="'/'"/>
          	Típusok lista
        </div>
      </div>
    </div>
	<div class="row d-flex justify-content-center m-2">
		<div class="col-12 col-sm-12 col-md-6 col-lg-4 text-center">
			<router-link :to="'/type/new_type'" class="btn btn-lg btn-outline-primary">
			    Új típus
			</router-link>
		</div>
	</div>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Név</th>
            <th scope="col">Megjegyzés</th>
            <th scope="col">Módosít</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in types" :key="index">
            <td>{{item.id}}</td>            
            <td>{{item.nev}}</td>
            <td>{{item.megjegyzes}}</td>
            <td>
              <router-link
                :to="`/types/${item.id}`"
              >
                Módosít
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'types',
  components: {
  },
  data () {
    return {
      types: []
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    load(){
      this.$Progress.start()
      this.req.post(`/types/search`)
        .then(res => {
        	this.types = res.data.types
          	this.$Progress.finish()
        })
        .catch(err => {
          console.log(err)
          this.$Progress.fail()
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/types/types.vue